import { useEffect, useRef, useState } from 'react'
import { createCrmContactActivity } from '../../db/api.js'
import DealTimeline from '../comercial/DealTimeline.jsx'

export default function ContactHistory({ contactId, onChanged, onOpenConversation }) {
  const [text, setText] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [revision, setRevision] = useState(0)
  const locked = useRef(false)
  const mounted = useRef(true)
  useEffect(() => {
    mounted.current = true
    return () => { mounted.current = false }
  }, [])
  const saveNote = async event => {
    event.preventDefault()
    const title = text.trim()
    if (!title || locked.current) return
    locked.current = true
    setSaving(true); setError('')
    try {
      await createCrmContactActivity(contactId, { tipo: 'mensagem', titulo: title })
      if (!mounted.current) return
      setText(''); setRevision(value => value + 1)
      onChanged?.()
    } catch (err) {
      if (mounted.current) setError(err.message || 'Não foi possível salvar a nota.')
    } finally {
      locked.current = false
      if (mounted.current) setSaving(false)
    }
  }
  return <div className="pm-dp-drawer dp-embedded dp-compact at-contact-history">
    <form className="cv-note-box" onSubmit={saveNote}>
      <div className="cv-note-head"><span className="cv-note-title">Nova nota</span></div>
      <textarea className="cv-note-textarea" rows={2} aria-label="Nota do contato" placeholder="Escreva uma nota sobre este contato…" value={text} disabled={saving} onChange={event => setText(event.target.value)} />
      {text.trim() && <div className="cv-note-foot"><button type="submit" className="cv-btn cv-btn-primary" disabled={saving}>{saving ? 'Salvando…' : 'Adicionar nota'}</button></div>}
      {error && <p role="alert" className="fc-error">{error}</p>}
    </form>
    <DealTimeline contactId={contactId} revision={revision} showEventActions onChanged={onChanged} onOpenConversation={onOpenConversation} />
  </div>
}
